import { FAQsPropertyItem } from '@mygpt/app/faqs-property/services/list';
import { Http } from '@mygpt/app/http';

export interface UpdateFAQsPropertyParams {
  // 数据集 ID
  datasetId: string;
  propertyId: string;
  title: string;
  type: string;
  description: string;
}

/**
 * 更新问答
 * @param params
 * @returns
 */
export const updateFAQsPropertyService = (params: UpdateFAQsPropertyParams) => {
  const { datasetId, propertyId, ...rest } = params;
  const { put } = Http.use();
  return put<FAQsPropertyItem>(`/datasets/${datasetId}/faqs/property?property_id=${propertyId}`, rest);
};
